import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Checkbox } from 'xm-spark';
import classnames from 'classnames';

import QuickStartIcon from 'resources/svg/quickstart-guide-book-icon.svg';
import { sections } from '../quickStartSections';
import { useShowQuickStartOnLogin, useQuickStartStatus } from '../hooks';
import { testIdPrefix } from '../constants';
import QuickStartProgressBar from '../QuickStartProgressBar';

import styles from './QuickStartHeader.module.scss';

export default function QuickStartHeader({ classes, setIsQuickStartOpen }) {
  const { completed, isLoading } = useQuickStartStatus();
  const [showQuickStartOnLogin, setShowQuickStartOnLogin] =
    useShowQuickStartOnLogin();

  return (
    <div
      className={classnames(styles.wrap, classes.wrap)}
      data-testid={`${testIdPrefix}__header`}
    >
      <div className={classnames(styles.header, classes.header)}>
        <QuickStartIcon className={styles.icon} />
        <h2 className={styles.headerText}>
          <FormattedMessage id="QUICK_START_HEADER_TITLE" />
        </h2>
      </div>

      <div className={classnames(styles.actions, classes.actions)}>
        {!!setIsQuickStartOpen && (
          <Button
            className={classnames(styles.closeButton, classes.closeButton)}
            icon="icon-cancel"
            onClick={() => setIsQuickStartOpen(false)}
            data-testid={`${testIdPrefix}__closeButton`}
          />
        )}
        <p>
          <FormattedMessage id="QUICK_START_HEADER_DESCRIPTION" />
        </p>
        <Checkbox
          className={styles.checkbox}
          checked={showQuickStartOnLogin}
          label={<FormattedMessage id="QUICK_START_HEADER_CHECKBOX_LABEL" />}
          onChange={() => setShowQuickStartOnLogin(!showQuickStartOnLogin)}
          data-testid={`${testIdPrefix}__showOnLoginCheckbox`}
        />
      </div>

      <QuickStartProgressBar
        sections={sections}
        completed={completed}
        isLoading={isLoading}
        testIdPrefix={testIdPrefix}
      />
    </div>
  );
}

QuickStartHeader.displayName = 'QuickStartHeader';
QuickStartHeader.propTypes = {
  classes: PropTypes.shape({
    wrap: PropTypes.string,
    header: PropTypes.string,
    actions: PropTypes.string,
    closeButton: PropTypes.string,
  }),
  setIsQuickStartOpen: PropTypes.func,
};
QuickStartHeader.defaultProps = {
  classes: {},
  setIsQuickStartOpen: null,
};
